import React from 'react';
import styled from 'styled-components';
import { BodyText, BodyTextProps } from '@make-software/cspr-ui';

const StyledBodyText = styled(BodyText)(({ theme }) =>
  theme.withMedia({
    padding: ['20px 20px 16px'],
      '&:where(h1, h2, h3, h4, h5, h6)': {
          margin: 0,
      },
  })
);

export const PageTileHeader = (props: Omit<BodyTextProps, 'size'>) => (
  <StyledBodyText scale={'lg'} variation={'black'} size={1} {...props} />
);
